/* @ngInject */
function HeaderController ($scope) {
  $scope.onFilter = (filter, hasPreFilters, filtersCount) => {
    if ($scope.toolbar?.search?.onFilter) {
      $scope.toolbar.search.onFilter(filter, hasPreFilters, filtersCount)
    } else if ($scope.toolbar?.advancedFilter?.onFilter) {
      $scope.toolbar.advancedFilter.onFilter(filter, hasPreFilters, filtersCount)
    }
  }

  $scope.onSearch = (search) => {
    if ($scope.toolbar?.search?.onSearch) {
      $scope.toolbar.search.onSearch(search)
    }
  }

  $scope.onCount = (count) => {
    if ($scope.toolbar?.search?.onCount) {
      $scope.toolbar.search.onCount(count)
    }
  }

  $scope.onBreadcrumbsChange = (event) => {
    $scope.breadcrumbs.onChange(event.detail)
  }

  $scope.onButtonClick = (event, button) => {
    if (button.pricing) {
      button.onClick(event)
    } else {
      button.onClick()
    }
  }
}

export { HeaderController }
